module.exports = __webpack_public_path__ + "static/media/screenshot-sample.32273a20.svg";